module.exports = __webpack_public_path__ + "img/bingo_ball-9.b555ed42.png";